import { render, staticRenderFns } from "./MattrzBaseLogo.vue?vue&type=template&id=cad73d22&"
import script from "./MattrzBaseLogo.vue?vue&type=script&lang=js&"
export * from "./MattrzBaseLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports